// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L5Jl","rootMobile":"styles_rootMobile__1eAsL"};